import React, { Component } from 'react';
import PropTypes from 'prop-types';
import equal from 'deep-equal';
import ReactDOM from 'react-dom';
import PriceFormatter from './formatterComponents/PriceFormatter';
import {decodeEntities} from '../api/utils';

class LineItem extends Component {
  // @todo Move highlight related stuff to HOC component.
  componentWillUpdate(newProps) {
    if (!equal(this.props,
      newProps)) {
      ReactDOM.findDOMNode(this).classList.add('highlight'); // eslint-disable-line react/no-find-dom-node
    }
  }

  componentDidUpdate() {
    const el = ReactDOM.findDOMNode(this); // eslint-disable-line react/no-find-dom-node
    setTimeout(() => el.classList.remove('highlight'),
      1000);
  }

  render() {
    let priceComponent;

    if (this.props.lineItem.price.amount === 0 && this.props.lineItem.priceDescription) {
      priceComponent = decodeEntities(this.props.lineItem.priceDescription);
    }
    else {
      priceComponent = <PriceFormatter price={this.props.lineItem.price} />;
    }

    return (
      <li className={this.props.lineItem.className}>
        <div>
          {decodeEntities(this.props.lineItem.name)}
          &nbsp;
          {this.props.lineItem.unitCount > 1 ? (
            <span className="unit-count">
              <span className="unit-count__times">&times;</span>
              &nbsp;
              <span className="unit-count__amount">{this.props.lineItem.unitCount}</span>
            </span>
          ) : null}
        </div>
        <div>
          {priceComponent}
        </div>
      </li>
    );
  }
}

LineItem.PropTypes = {
  lineItem:PropTypes.object.isRequired,
};

export default LineItem;
